import { useEffect } from "react";
import { ErrorPage } from "processhub-components-lib";
import ProgressMonitoringLogo from "components/shared/ProgressMonitoringLogo";

const LoginErrorPage = () => {

  return (
    <ErrorPage>
      <ProgressMonitoringLogo variant="regular" />
    </ErrorPage>
  );
};

export default LoginErrorPage;